import React from 'react';
import { Section } from './ui/Section';
export function BonusSection() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/nBHycezXfKtJw92fLEEpgw/portada_bono_1.png',
    title: 'Guía de Mensajes de Texto para Reducir Conflictos™',
    desc: '25 mensajes de texto listos para copiar y pegar que calman cualquier discusión por WhatsApp.',
    value: 'Valor: $19'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/mfQsrshLShwGu2bTks1AtS/portada_bono_2.png',
    title: 'Qué Decir Cuando Él Se Cierra™',
    desc: 'PDF descargable con frases y estrategias prácticas para cuando él aplica la ley del hielo.',
    value: 'Valor: $27'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/9Q4hcFw7ooaQM5KC9hdSP2/portada_bono_3.png',
    title: 'Scripts de Emergencia™',
    desc: 'Frases instantáneas para momentos de alto estrés donde necesitas actuar rápido.',
    value: 'Valor: $15'
  }];
  return <Section background="lavender" data-id="element-20">
      <div className="text-center mb-12" data-id="element-21">
        <span className="text-purple-600 font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-22">
          Oferta Especial Limitada
        </span>
        <h2 className="text-3xl font-bold text-gray-900" data-id="element-23">
          Además, recibes estos 3 bonos{' '}
          <span className="text-purple-600" data-id="element-24">GRATIS</span>
        </h2>
        <p className="mt-4 text-gray-600" data-id="element-25">
          Herramientas adicionales para acelerar tus resultados, incluidas sin
          costo adicional.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-3" data-id="element-26">
        {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-2xl shadow-md border border-purple-100 flex flex-col h-full overflow-hidden transition-transform hover:-translate-y-1" data-id="element-27">
            <div className="relative" data-id="element-28">
              <img src={bonus.image} alt={`Portada de ${bonus.title}`} className="w-full aspect-[3/4] object-cover" data-id="element-29" />
            </div>
            <div className="p-6 flex flex-col flex-grow" data-id="element-30">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-31">
                {bonus.title}
              </h3>
              <p className="text-gray-600 mb-4 flex-grow" data-id="element-32">{bonus.desc}</p>
              <div className="pt-4 border-t border-gray-100" data-id="element-33">
                <span className="text-sm font-semibold text-gray-400 line-through mr-2" data-id="element-34">
                  {bonus.value}
                </span>
                <span className="text-sm font-bold text-green-600" data-id="element-35">
                  GRATIS HOY
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}